import { cartTotalStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingCartTotal";
import { pageHeaderStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

pageHeaderStyles.continueButton = {
    mergeCss:true,
    css: css`
        width: 100%;
        span {
            color: #FFFFFF;
        }
    `,
}

cartTotalStyles.continueButton = {
    mergeCss:true,
    variant: "primary",
    css: css`
        span {
            color: #FFFFFF;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    width: 100%;
                `,
                css`
                    width: 100%;
                `,
                css`
                    width: 100%;
                `,
                css`
                    width: 100%;
                `,
                css`
                    width: 100%;
                `,
            ])}
    `,
}
pageHeaderStyles.buttonsWrapper = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    display:none;
                    // position: fixed;
                    // left: 0;
                    // bottom: 0;
                    // width: 100%;
                    // z-index: 1;
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
            ])}
    `,
}

cartTotalStyles.buttonsGridItem={
        width: 12,
}